module.exports = __webpack_public_path__ + "static/media/notification-blank.eaa16573.svg";